<template>
  <div>
      <v-alert v-if="showAlert" density="compact" :type="alertType" @click="showAlert = false">
        <template v-slot:title>
          {{ alertTitle }}
        </template>
        {{ alertText }}
        <v-btn icon @click="Logout()">
          Sair
      </v-btn>
      </v-alert>
      <v-alert v-if="showAlert2" density="compact" :type="alertType2" @click="showAlert2 = false">
        <template v-slot:title>
          {{ alertTitle2 }}
        </template>
        {{ alertText2 }}
      </v-alert>
    <div class="container" v-if="User != ''">
      <div class="page-inner">
        <div class="d-flex align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-4">
          <div>
            <h3 class="fw-bold mb-3">Olá {{ User.nome }}</h3>
          </div>
        </div>
        <garante-pay-dashboard
          v-if="User.tipo == 0"
          :pedidos="ListPedidosDashboard"
          :garantidoras-count="ListGarantidorasGeral"
          :garantidoras-bloqueadas-count="ListGarantidorasBloqueadas"
          :imobiliarias-count="ListImobiliariasGeral"
          :clientes-count="ListClientesGeral"
          :receita-carteira="ReceitaCarteira"
          :garantidoras-lista="GarantidorasDashboard"
          :garantidoras-sem-vigentes="GarantidorasSemVigentes"
          :sinistros-por-etapa="SinistrosPorEtapa"
          :consultas-realizadas="ListPedidosPesquisados"
          :assinaturas-realizadas="ListPedidosAssinados"
          :total-consultas="totalCpc2"
          :total-assinaturas="totalCpc1"
        />
        <parceiro-dashboard
          v-if="User.tipo == 1 || User.tipo == 3"
          :tipo-usuario="User.tipo"
          :pedidos="ListPedidosDashboard"
          :imobiliarias-count="ListImobiliariasGeral"
          :clientes-count="ListClientesGeral"
          :consultas-realizadas="ListPedidosPesquisados"
          :saldo-consultas="SaldoConsultas"
          :assinaturas-realizadas="ListPedidosAssinados"
          :saldo-assinaturas="SaldoAssinaturas"
          :receita-carteira="ReceitaCarteira"
          :sinistros-por-etapa="SinistrosPorEtapa"
          :parcelas-acordos="ParcelasAcordos"
          :pagamentos-agendados="PagamentosAgendados"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import authService from '../auth/oidc'
import GarantePayDashboard from '../components/dashboard/GarantePayDashboard.vue'
import ParceiroDashboard from '../components/dashboard/ParceiroDashboard.vue'

export default {
  name: 'HomeView',
  components: {
    GarantePayDashboard,
    ParceiroDashboard
  },
  data: () => ({
    accordion: false,
    User: [],
    ListaMeusContratos: [],
    libera: [],
    showAlert: false, // Controle de visibilidade do alerta
    alertTitle: '', // Título do alerta
    alertText: '', // Texto do alerta
    alertType: '', // Tipo do alerta (success, warning, error, etc.)
    //
    showAlert2: false, // Controle de visibilidade do alerta
    alertTitle2: '', // Título do alerta
    alertText2: '', // Texto do alerta
    alertType2: 'warning', // Tipo do alerta (success, warning, error, etc.)
    // dashboard
    ListGarantidorasGeral: 0,
    ListGarantidorasBloqueadas: 0,
    ListPedidosGeral: [],
    ListPedidosDashboard: [],
    ListPedidosAtendimento: [],
    ListPedidosNegados: [],
    ListPedidosPesquisados: [],
    ListPedidosAssinados: [],
    SaldoConsultas: 0,
    SaldoAssinaturas: 0,
    headers: [],
    searchValue: '',
    ListImobiliariasGeral: 0,
    ListClientesGeral: 0,
    ReceitaCarteira: [],
    GarantidorasDashboard: [],
    GarantidorasSemVigentes: [],
    SinistrosPorEtapa: [],
    ParcelasAcordos: [],
    PagamentosAgendados: [],
    PlanoGarantidora: '',
    totalCpc1: 0,
    totalCpc2: 0,
    itemsSelected: [],
    ConfiguraSinistroGar: [],
    situacoesMenu: [
      { id: 1, label: 'Aguardando Análise' },
      { id: 2, label: 'Análise Manual' },
      { id: 8, label: 'Aguardando Documentos' },
      { id: 14, label: 'Processando Análise de Crédito' },
      { id: 15, label: 'Gerar Contrato' },
      { id: 13, label: 'Preparando Envio Assinatura' },
      { id: 9, label: 'Aguardando Assinatura' },
      { id: 5, label: 'Aprovado Gerar Cobrança' },
      { id: 7, label: 'Aguardando Pagamento' },
      { id: 0, label: 'Todos' }
    ]
  }),
  methods: {
    statusClass (pspId) {
      const map = {
        8: 'btn-warning', // mantém (warning)
        9: 'btn-dark', // mantém (black)
        7: 'btn-info',
        2: 'btn-secondary',
        1: 'btn-primary',
        5: 'btn-orange', // custom
        13: 'btn-purple', // custom
        14: 'btn-teal', // custom
        15: 'btn-pink' // custom
      }

      return map[pspId] || 'btn-light'
    },
    formattedDate (value) {
      return this.$moment(value).format('DD/MM/YYYY')
    },
    async Logout () {
      await authService.signOutRedirect()
    },
    onReady (editor) {
      // Insert the toolbar before the editable area.
      editor.ui.getEditableElement().parentElement.insertBefore(
        editor.ui.view.toolbar.element,
        editor.ui.getEditableElement()
      )
    },
    preprocessData (data) {
      return data.map(item => {
        return {
          ...item,
          proOrdem: parseInt(item.proOrdem)
        }
      })
    },
    formattedDate (value) {
      if (value != null || value != '') {
        return this.$moment(value).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    formatarValor (valor) {
      return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
    },
    montaGrid () {
      this.headers = []
      this.headers.push({ text: 'Id', value: 'pedId', sortable: true })
      this.headers.push({ text: 'Data', value: 'pedDataPedido', sortable: true })
      if (this.User.tipo == 0) {
        this.headers.push({ text: 'Garantidora', value: 'garNome', sortable: true })
      }
      if (this.User.tipo != 3) {
        this.headers.push({ text: 'Imobiliaria', value: 'imobNome', sortable: true })
      }
      this.headers.push({ text: 'Cliente', value: 'cliNome', sortable: true })
      this.headers.push({ text: 'Valor', value: 'pedValorTotalPedido', sortable: true })
      this.headers.push({ text: 'Situação', value: 'pedSituacaoPedido', sortable: true })
    },
    EditGrid (item) {
      this.$router.push('/contratacaodetalhe/' + item.pedId)
    }
  },
  async created () {
    const urlGarantidora = authService.getActiveGuarantorUrl()

    await axios.get('/Telas/Home/GetDados')
      .then(response => {
        console.log('response')
        console.log(response)
        if (response.data.bloqueioGarantidora) {
          localStorage.removeItem('_useravgar')
          this.$router.push('/')
        } else if (response.data.validaContratosGar.length > 0) {
          this.alertTitle = 'Assinatura Pendente'
          this.alertText = 'Identificamos assinatura de contrato pendente, verifique seu e-mail ou entre em contato com suporte GarantePay.'
          this.alertType = 'warning'
          this.showAlert = true
        } else if (response.data.validaContratosImo.length > 0) {
          this.alertTitle = 'Assinatura Pendente'
          this.alertText = 'Identificamos assinatura de contrato pendente, verifique seu e-mail ou entre em contato com suporte da sua Garantidora.'
          this.alertType = 'warning'
          this.showAlert = true
        } else {
          let _mostraAlert2 = false
          const _validaConfigSinistroGar = response.data.garantidoraConfigSinistro
          if ((_validaConfigSinistroGar == null || _validaConfigSinistroGar == '') && response.data.tipo != 0) {
            _mostraAlert2 = true
          } else if (_validaConfigSinistroGar != '' && _validaConfigSinistroGar != null && response.data.tipo != 0) {
            if (_validaConfigSinistroGar[0].gscEmailAprovacao === '' || _validaConfigSinistroGar[0].gscEmailAprovacao === null) {
              _mostraAlert2 = true
            } else if (_validaConfigSinistroGar[0].gscEmailPagamento === '' || _validaConfigSinistroGar[0].gscEmailPagamento === null) {
              _mostraAlert2 = true
            } else if (_validaConfigSinistroGar[0].gscEmailCobranca === '' || _validaConfigSinistroGar[0].gscEmailCobranca === null) {
              _mostraAlert2 = true
            } else if (_validaConfigSinistroGar[0].gscEmailFinanceiro === '' || _validaConfigSinistroGar[0].gscEmailFinanceiro === null) {
              _mostraAlert2 = true
            } else if (_validaConfigSinistroGar[0].gscEmailJuridico === '' || _validaConfigSinistroGar[0].gscEmailJuridico === null) {
              _mostraAlert2 = true
            } else if (_validaConfigSinistroGar[0].gscMulta === '' || _validaConfigSinistroGar[0].gscMulta === null) {
              _mostraAlert2 = true
            } else if (_validaConfigSinistroGar[0].gscJuroDiario === '' || _validaConfigSinistroGar[0].gscJuroDiario === null) {
              _mostraAlert2 = true
            }
          }

          if (_mostraAlert2) {
            this.alertTitle2 = 'Cadastro Pendente'
            this.alertText2 = 'Identificamos que dados de configuração de Sinistro, na Tela Garantidora (aba Sinistro) devem ser preenchidos. ' + (response.data.tipo == 3 ? ' Contate sua Garantidora' : '')
            this.alertType2 = 'warning'
            this.showAlert2 = true
          }

          const _dadoUser = {
            nome: response.data.userNome,
            urlimage: response.data.userImagem,
            garlogo: response.data.garLogo,
            urlGarantidora,
            tipo: response.data.tipo,
            tusid: response.data.tusId,
            menu: response.data.menu
          }
          localStorage.setItem('_useravgar', JSON.stringify(_dadoUser))

          this.ListGarantidorasGeral = response.data.garCount
          this.ListGarantidorasBloqueadas = response.data.garBloqueadasCount || 0
          this.ListImobiliariasGeral = response.data.imobCount || 0
          this.ListClientesGeral = response.data.clientesCount || 0
          this.ReceitaCarteira = Array.isArray(response.data.receitaCarteira) ? response.data.receitaCarteira : []
          this.GarantidorasDashboard = Array.isArray(response.data.garantidorasDashboard) ? response.data.garantidorasDashboard : []
          this.GarantidorasSemVigentes = Array.isArray(response.data.garantidorasSemVigentes) ? response.data.garantidorasSemVigentes : []
          this.SinistrosPorEtapa = Array.isArray(response.data.sinistrosPorEtapa) ? response.data.sinistrosPorEtapa : []
          this.ParcelasAcordos = Array.isArray(response.data.parcelasAcordos) ? response.data.parcelasAcordos : []
          this.PagamentosAgendados = Array.isArray(response.data.pagamentosAgendados) ? response.data.pagamentosAgendados : []
          this.ListPedidosPesquisados = response.data.consultasRealizadasDashboard ?? response.data.validaConsultas.totalConsultasRealizadas
          this.ListPedidosAssinados = response.data.validaConsultas.totalAssinaturasRealizadas
          this.SaldoConsultas = response.data.validaConsultas.saldoConsultas || 0
          this.SaldoAssinaturas = response.data.validaConsultas.saldoAssinaturas || 0
          this.totalCpc1 = response.data.validaConsultas.totalAssinaturas
          this.totalCpc2 = response.data.validaConsultas.totalConsultas
          this.ListPedidosDashboard = Array.isArray(response.data.listaPedidos) ? response.data.listaPedidos : []
          this.ListPedidosGeral = this.ListPedidosDashboard.filter(x => x.pspId == 3)
          this.ListPedidosAtendimento = this.ListPedidosDashboard.filter(x => x.pspId != 6 && x.pspId != 3 && x.pspId != 4)
          this.ListPedidosNegados = this.ListPedidosDashboard.filter(x => x.pspId == 6 || x.pspId == 4)
          this.User = _dadoUser
          this.PlanoGarantidora = response.data.planoGarantidora
          this.montaGrid()
          window.dispatchEvent(new CustomEvent('menu:updated'))
        }
      })
  }
}
</script>

<style>

 .status-btn{
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 6px;
  border: 0;
  margin: 3px;
}

/* mantém warning e dark do bootstrap */

/* cores custom (todas diferentes) */
.btn-orange { background:#ff7a00; color:#fff; }
.btn-purple { background:#6f42c1; color:#fff; }
.btn-teal   { background:#20c997; color:#fff; }
.btn-pink   { background:#e83e8c; color:#fff; }

/* se usar btn-light como fallback */
.btn-light { background:#f1f3f5; color:#212529; }

</style>
